<section class="header">
  <p-menubar
    [model]="items"
    (click)="toggleMenu()"
    styleClass="flex flex-wrap justify-content-start md:justify-content-between">
    <ng-template pTemplate="start">
      <img
        routerLink="/"
        src="assets/img/logotipos/logo-scuba-ondas.jpg"
        alt="Logotipo Scubamedic - Seguros de buceo"
        class="logo_principal img-responsive mr-2 w-10rem sm:w-14rem cursor-pointer" />
      @if (languagePrefix !== 'de' && showLoginButton()) {

      <div class="p-menuitem-content" data-pc-section="content">
        <ls-button-atom
          type="submit"
          i18n-label="@@login.button.inicio"
          styleClass="w-full p-3 uppercase hidden sm:block"
          severity="primary"
          size="small"
          label="Acceso centros de buceo"
          type="button"
          (onClick)="this.router.navigate(['/login'])" />

        <ls-button-atom
          type="submit"
          i18n-label="@@login.button.inicio"
          styleClass="w-full p-2 uppercase sm:hidden md:hidden lg:hidden"
          severity="primary"
          size="small"
          label="Acceso centros"
          type="button"
          (onClick)="this.router.navigate(['/login'])" />
      </div>
      }
    </ng-template>
  </p-menubar>
</section>
